import { render, staticRenderFns } from "./left-arrow-green.vue?vue&type=template&id=1988ad64&scoped=true&"
import script from "./left-arrow-green.vue?vue&type=script&lang=js&"
export * from "./left-arrow-green.vue?vue&type=script&lang=js&"
import style0 from "./left-arrow-green.vue?vue&type=style&index=0&id=1988ad64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988ad64",
  null
  
)

export default component.exports